import { FeatureInstance } from 'lane-shared/types/FeatureInstance';
import { FeatureNameEnum } from 'constants-content';
import { ReservableFeatureProperties } from 'lane-shared/types/features/ReservableFeatureProperties';

export function isReservableFeatureInstance(
  feature: any
): feature is FeatureInstance<ReservableFeatureProperties> {
  return feature?.type === FeatureNameEnum.Reservable;
}
